import { render, staticRenderFns } from "./SignalR.vue?vue&type=template&id=16bd2f9c"
import script from "./SignalR.vue?vue&type=script&lang=ts"
export * from "./SignalR.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports